var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-base',{attrs:{"lead-state":"initiated"},scopedSlots:_vm._u([{key:"subtitle",fn:function(){return [_vm._v("Initiating call...")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }